import { render, staticRenderFns } from "./POIMappingFields.vue?vue&type=template&id=8d799ce4"
import script from "./POIMappingFields.js?vue&type=script&lang=js&external"
export * from "./POIMappingFields.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports